var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{on:{"toggleSideNav":_vm.toggleNav}}),(_vm.$route.meta.hasSubNav)?_c('SubNav'):_vm._e(),_c('SearchOverlay'),_c('div',{staticClass:"app",class:{'app-search-open':_vm.searchOpen}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }